<template>
    <section class="hero-slider">
        <Carousel v-bind="config" class="carousel">
            <Slide v-for="item in this.slides" :key="item.id">
                <div class="slide-wrapper">
                    <img :src="item.image" alt="" />

                    <!--<div class="overlay"></div>-->

                    <div v-if="item.slider_header || item.slider_paragraph || (item.button_url && item.button_text)" class="content">
                        <h1 v-if="item.slider_header" class="slider-header">{{ item.slider_header }}</h1>
                        <p v-if="item.slider_paragraph" class="slider-paragraph">{{ item.slider_paragraph }}</p>
                        <a class="button" v-if="item.button_url && item.button_text" :href="item.button_url" :target="item.button_target" >
                            {{ item.button_text }}
                        </a>
                    </div>
                </div>
            </Slide>

            <template #addons>
                <Navigation />
                <Pagination />
            </template>
        </Carousel>
    </section>
</template>


<script>
import 'vue3-carousel/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

    export default {
        props: {
            fade: Boolean,
            slides: Array
        },
        components: {
            Carousel, Slide, Pagination, Navigation
        },
        data() {
            return {
                config: {
                    height: 400,
                    itemsToShow: 1,
                    wrapAround: true,
                    autoplay: 5000,
                    pauseAutoplayOnHover: true,
                    transition: 800,
                },
            }
        },


    }
</script>

<style scoped>
.hero-slider {
    width: 100%;
    background: #0f172a;
    margin-top: 0 !important;
}

.hero-slider > section {
    margin-top: 0 !important;
}

.carousel {
    --vc-pgn-background-color: rgba(255, 255, 255, 0.4);
    --vc-pgn-active-color: #ffffff;
    --vc-nav-background: rgba(255, 255, 255, 0.3);
    --vc-nav-border-radius: 50%;
}

.slide-wrapper {
    position: relative;
    height: 580px;
    overflow: hidden;
}

.slide-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(85%);
    transition: transform 6s ease;
}

/* Content positioning */
.content {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 75%;
    justify-content: space-between;
    padding: 2rem 0;
    position: absolute;
    text-align: center;
    top: 5%;
    width: 100%;
    z-index: 10;
}

@media (max-width: 1018px) {
    .content {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 75%;
        justify-content: space-between;
        padding: 2rem 0;
        position: absolute;
        text-align: center;
        top: 9%;
        width: 100%;
        z-index: 10;
    }
}

/* Navigation arrows styling */
.carousel :deep(.carousel__prev),
.carousel :deep(.carousel__next) {
    width: 45px;
    height: 45px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(6px);
    border-radius: 50%;
    transition: all 0.3s ease;
}

.carousel :deep(.carousel__prev:hover),
.carousel :deep(.carousel__next:hover) {
    background: rgba(255, 255, 255, 0.5);
}
</style>
